import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const ORGANIZATION_ID = new InjectionToken<
	BehaviorSubject<string | null>
>('OrganizationIdToken');
